import { RouteFragment } from "@impero-com/common/routeFragments";
import { assertNever } from "@impero-com/common/utils/obj";
import { withRestoreParam } from "@impero-com/ui/domain";
import { z } from "zod";

import { WebRoute } from "routes";

import { ControlActivitiesScope } from "./list/consts";

export const controlProgramIdParamSchema = z.coerce.number().int().positive();
export const controlIdParamSchema = z.guid();

function buildControlActivitiesListPath(scope: ControlActivitiesScope) {
    switch (scope.type) {
        case "all":
            return WebRoute.CONTROL_ACTIVITIES;
        case "controlProgram":
            return `${WebRoute.CONTROL_PROGRAMS}/${scope.controlProgramId.toString()}/${RouteFragment.CONTROL_ACTIVITIES}` as const;
        case "control":
            return `${WebRoute.CONTROLS}/${scope.controlId}/${RouteFragment.CONTROL_ACTIVITIES}` as const;
        default:
            return assertNever(scope);
    }
}

/** Links to a scope's activities list, which then restores that scope's saved view. */
export function buildControlActivitiesListUrl(
    scope: ControlActivitiesScope
): string {
    return withRestoreParam(buildControlActivitiesListPath(scope));
}
